<template>
  <label class="flex cursor-pointer select-none items-center">
    <div class="relative">
      <input type="checkbox" class="sr-only" @change="handleCheckboxChange" />
      <div class="block h-8 w-14 rounded-full border-2 border-quaternary bg-primary"></div>
      <div
        :class="{
          'left-8': isChecked,
          'left-2': !isChecked
        }"
        class="absolute top-1/2 h-3 w-4 -translate-y-1/2 rounded-full border-2 border-quaternary bg-primary transition-all"
      ></div>
    </div>
  </label>
</template>

<script setup lang="ts">
const isChecked = defineModel<boolean>()

const emit = defineEmits(['change'])

const handleCheckboxChange = () => {
  isChecked.value = !isChecked.value
  emit('change', !isChecked.value)
}
</script>
